import "@/App.css";
import { BrowserRouter, Routes, Route, useParams, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Community, { Creators } from "@/pages/Community";
import PostDetail from "@/pages/PostDetail";
import Profile from "@/pages/Profile";
import Chat from "@/pages/Chat";
import Shop, { Categories } from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import { OrderSuccess, Orders } from "@/pages/Orders";
import { ReferEarn, ReferralDashboard, WalletPage } from "@/pages/Referral";
import { Festivals, FestivalDetail, PujaIdeas, Content, ArticleDetail, WomensCommunity, QuestionPage } from "@/pages/Discover";
import { SearchPage, Notifications, Login, Onboarding, StaticPage } from "@/pages/Misc";
import Admin from "@/pages/Admin";
import { Empty } from "@/components/common";

const Static = () => <StaticPage slug={useParams().slug} />;
const NotFound = () => <div className="container-x py-16"><Empty title="Page not found" sub="The page you are looking for doesn't exist." action={<Link to="/" className="btn-maroon">Go home</Link>} /></div>;

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/community" element={<Community />} />
            <Route path="/creators" element={<Creators />} />
            <Route path="/post/:id" element={<PostDetail />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile/:id" element={<Profile />} />
            <Route path="/community-chat" element={<Chat />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order-success/:id" element={<OrderSuccess />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/refer-and-earn" element={<ReferEarn />} />
            <Route path="/referral-dashboard" element={<ReferralDashboard />} />
            <Route path="/wallet" element={<WalletPage />} />
            <Route path="/festivals" element={<Festivals />} />
            <Route path="/festivals/:slug" element={<FestivalDetail />} />
            <Route path="/puja-ideas" element={<PujaIdeas />} />
            <Route path="/content" element={<Content />} />
            <Route path="/content/:slug" element={<ArticleDetail />} />
            <Route path="/womens-community" element={<WomensCommunity />} />
            <Route path="/questions/:id" element={<QuestionPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/login" element={<Login />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/page/:slug" element={<Static />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors />
      </AppProvider>
    </BrowserRouter>
  );
}
